import React, { useEffect, useState } from "react";

import Accordion from "../accordion";
import LocaleGallery from "./locale-gallery";
import TaskNav from "../task-nav/task-nav";

import { Select } from "../form-inputs/inputs";
import { useInput } from "../../shared/hooks/form-fields";
import { getShipmentProductContexts, getOriginalProductShots } from "./lib/imageData";
import { getPhotos } from "../photography/lib/photoData";
import { sortShots } from "../photography/lib/helpers";
import { lookupUUID } from "../../shared/attribute-uuid";
import { getAttributeByUUID, readOnlyValue } from "../attributes/lib/attribute-data";
import { useParams } from "react-router-dom";
import { groupBy } from "lodash";

const versionOptions = [
    { value: "edited", text: "Edited" },
    { value: "unedited", text: "Unedited" },
    { value: "all", text: "All" },
];

const ImageBrowserIndex = () => {
    const params = useParams();
    const shipmentKey = params.shipmentKey;
    const shipmentProductKey = params.shipmentProductKey;
    const versionSelect = useInput(params.version || "unedited");
    const [state, setState] = useState({
        currentProduct: null,
        currentIndex: 0,
        hierarchyProducts: [],
        shotsByPhotoWipKey: {},
        title: "",
        originalProductShots: null,
        originalShipmenProduct: [],
    });

    useEffect(() => {
        async function fetchData() {
            const shipmenProductContexts = await getShipmentProductContexts(shipmentKey, shipmentProductKey);
            const originalProductShots = await getOriginalProductShots(shipmentKey, shipmentProductKey);
            const originalShipmenProductContexts =
                originalProductShots.originalShipmentKey !== null && originalProductShots.originalShipmentProductKey
                    ? await getShipmentProductContexts(originalProductShots.originalShipmentKey, originalProductShots.originalShipmentProductKey)
                    : null;

            const currentProduct = shipmenProductContexts.find((p) => p.shipmentProductKey === shipmentProductKey);
            const currentIndex = shipmenProductContexts.findIndex((p) => p.shipmentProductKey === shipmentProductKey);
            const wipkeys = shipmenProductContexts.map((p) => p.photographyWipKey);
            const allShots = await getPhotos(wipkeys, false);
            const shotsByPhotoWip = groupBy(allShots.sort(sortShots), "photographyWipKey");
            const pdfFiles = currentProduct ? await getAttributeByUUID(currentProduct.codingWipKey, lookupUUID("pdfFiles")) : null;
            const allEditedOriginalShots = originalProductShots.originalShots.length > 0 ? originalProductShots.originalShots : null;

            setState({
                currentIndex: currentIndex,
                currentProduct: currentProduct,
                hierarchyProducts: shipmenProductContexts,
                shotsByPhotoWipKey: shotsByPhotoWip,
                title: currentProduct ? `${currentProduct.label}` : "",
                pdfFiles: pdfFiles,
                originalShipmenProduct: originalShipmenProductContexts,
                originalProductShots: allEditedOriginalShots,
            });
        }

        fetchData();
    }, []);

    useEffect(() => {
        document.title = state.currentProduct ? `${state.currentProduct.fullUpc} - Image Browser` : `Image Browser`;
    }, [state.currentProduct]);

    const accordion =
        state.hierarchyProducts.length > 0 ? (
            <Accordion startingIndex={state.currentIndex} loadOnOpen={false}>
                {state.hierarchyProducts.map((p, index) => {
                    return (
                        <LocaleGallery
                            key={`accordion_${index}`}
                            label={p.label}
                            localeByKey={state.localeByKey}
                            shots={state.shotsByPhotoWipKey[p.photographyWipKey]}
                            photographyWipKey={p.photographyWipKey}
                            version={versionSelect.value}
                        />
                    );
                })}
            </Accordion>
        ) : null;

    const originalsAccordion =
        state.originalShipmenProduct !== null && state.originalShipmenProduct.length > 0 ? (
            <Accordion startingIndex={state.currentIndex + 1} loadOnOpen={true}>
                {state.originalShipmenProduct.map((p, index) => {
                    return <LocaleGallery key={`original_${index}`} label={`${p.label} (Old Duplicate Matched Product)`}
                        shots={state.originalProductShots} photographyWipKey={p.photographyWipKey}
                        version={"edited"} />; 
                })}
            </Accordion>
        ) : null;

    return (
        <div className="container">
            <TaskNav>
                <h1>Image Browser {state.title && `- ${state.title}`}</h1>
            </TaskNav>
            <Select name="version" {...versionSelect.bind} options={versionOptions} excludeSelect={true} />
            {accordion}
            {state.originalProductShots && state.originalProductShots.length > 0 && originalsAccordion}
            {state.pdfFiles && state.pdfFiles.value && <h2>PDF Files</h2>}
            {state.pdfFiles && state.pdfFiles.value && readOnlyValue(state.pdfFiles.value, state.pdfFiles.componentType, state.pdfFiles)}
        </div>
    );
};

export default ImageBrowserIndex;
